import { ReactElement, useState } from 'react';
import { useFormikContext } from 'formik';
import { Button } from '@components';
import { navigateToError } from '@utils';
import { iExtensionFormValues } from '@services/ExtensionService';

import styles from './ExtensionStep12.module.scss';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

function ExtensionStep12(): ReactElement {
  const [loading, setLoading] = useState(false);
  const { values }: { values: iExtensionFormValues } = useFormikContext();

  return (
    <>
      {!loading && (
      <>
        <div className="vfH2">You're not eligible to go to court</div>
        <p className={styles.intro}>
          Your fine is for
          {values.DDD && (<span> a drunk or drug-driving</span>)}
          {values.ESI && (<span> an excessive speed</span>)}
          {values.MarineOffence && (<span> a drink or drug-boating</span>)}
          {' offence and you are outside 28 days of your Infringement Notice issue date. You\'re not able to elect to go to court.'}
        </p>
        <p className={styles.subtext}>
          {'To speak to someone, contact Fines Victoria on '}
          <a className={styles.contactLink} href="tel:0392008111" title="Fines Victoria phone number">03 9200 8111</a>
          {' or '}
          <a className={styles.contactLink} href="tel:1300369819" title="Fines Victoria phone number">1300 369 819</a>
          {' (for regional callers).'}
        </p>
        <p className={styles.subtext}>We're available Monday to Friday, 8am to 6pm (except public holidays).</p>
        <p className={styles.subtext}>Pay now to avoid additional costs.</p>
        <div className={styles.row}>
          {/* Pay your fines */}
          <Button
            onClick={async (): Promise<void> => {
              const url = `${API_URL}sitecore/Payment/Pay`;
              const data = new FormData();
              data.append('identifier', values.OBLIGATION_NUMBER);
              data.append('payFine', 'Pay your fines');

              try {
                const res = await fetch(url, {
                  method: 'POST',
                  body: data,
                });
                window.location.href = res.url;
              } catch (error) {
                navigateToError();
              }
            }}
            size="medium"
            color="blue"
            className={styles.button}>
            Pay your fines
          </Button>

          {/* View your fines */}
          <Button
            onClick={async (): Promise<void> => {
              setLoading(true);
              const payload = {
                page: 'fines.YourFinesListID',
              };
              const url = `${API_URL}sitecore/Navigation/GetUrl`;
              let response: any;
              try {
                response = await fetch(url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(payload),
                });
                const responseUrl = await response.json();
                setLoading(false);
                if (response.status === 200) {
                  window.location.href = responseUrl;
                  return;
                }
                navigateToError();
              } catch (error) {
                navigateToError();
              }
            }}
            size="medium"
            color="transparent"
            className={styles.button}>
            View your fines
          </Button>
        </div>
        <div className={styles.note}>
          <a className={styles.finesLink} href="/About-Fines/What-happens-if-you-dont-pay">Find out what could happen if you don't pay</a>
        </div>
      </>
      )}
    </>
  );
}

export default ExtensionStep12;
